import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const IconSvg = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.0805 14.227L11.4772 10.6236C12.4592 9.4227 12.942 7.89028 12.8257 6.34335C12.7095 4.79643 12.0032 3.35335 10.8528 2.31262C9.70241 1.27188 8.19604 0.713116 6.64524 0.751891C5.09444 0.790666 3.61787 1.42402 2.52094 2.52094C1.42402 3.61787 0.790666 5.09444 0.751891 6.64524C0.713116 8.19604 1.27188 9.70241 2.31262 10.8528C3.35335 12.0032 4.79643 12.7095 6.34335 12.8257C7.89028 12.942 9.4227 12.4592 10.6236 11.4772L14.227 15.0805C14.3408 15.1905 14.4933 15.2514 14.6516 15.25C14.8099 15.2486 14.9613 15.1851 15.0732 15.0732C15.1851 14.9613 15.2486 14.8099 15.25 14.6516C15.2514 14.4933 15.1905 14.3408 15.0805 14.227ZM6.80603 11.6354C5.85087 11.6354 4.91716 11.3522 4.12298 10.8215C3.32879 10.2908 2.7098 9.5366 2.34428 8.65415C1.97875 7.7717 1.88312 6.80067 2.06946 5.86387C2.2558 4.92706 2.71575 4.06655 3.39115 3.39115C4.06655 2.71575 4.92706 2.2558 5.86387 2.06946C6.80067 1.88312 7.7717 1.97875 8.65415 2.34428C9.5366 2.7098 10.2908 3.32879 10.8215 4.12298C11.3522 4.91716 11.6354 5.85087 11.6354 6.80603C11.634 8.08641 11.1247 9.31395 10.2193 10.2193C9.31395 11.1247 8.08641 11.634 6.80603 11.6354Z"
      fill="#151718"
    />
  </svg>
);

const SearchIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={IconSvg} {...props} />
);

export default SearchIcon;
